import { Box, BoxProps } from "@chakra-ui/react";
import { ReactNode } from "react";

interface CollapsibleNavBarProps {
  isCollapsed?: boolean;
  children?: ReactNode;
  nonCollapsibleChildren?: ReactNode;
  shouldCollapse?: boolean;
  boxProps?: BoxProps;
}

export function CollapsibleNavBar({
  isCollapsed = false,
  children,
  nonCollapsibleChildren,
  shouldCollapse = true,
  boxProps,
}: CollapsibleNavBarProps) {
  return shouldCollapse ? (
    <Box
      width="full"
      transform={!isCollapsed ? "translateY(0)" : "translateY(-100%)"}
      transition="opacity 0.2s ease-out, transform 0.1s ease-out"
      opacity={nonCollapsibleChildren ? 1 : isCollapsed ? 0 : 1}
      {...boxProps}
    >
      <Box opacity={isCollapsed ? 0 : 1} transition="opacity 0.2s ease-out">
        {children}
      </Box>
      {nonCollapsibleChildren ? nonCollapsibleChildren : null}
    </Box>
  ) : (
    <Box {...boxProps}>
      {children}
      {nonCollapsibleChildren}
    </Box>
  );
}
